import React from "react";

// STYLES
import * as Style from "./DiscountCardStyle";

// LIBRARIES
import { useNavigate } from "react-router-dom";

// MISC
import { IProps } from "./DiscountCardModel";

// ASSETS
import LogoIcon from "assets/Icons/IsupIcon.svg";
import DeleteButton from "assets/Icons/DeleteButton.svg";

// REDUX
import { useAppDispatch } from "hooks/reduxHooks";
import { toggleModalState } from "slices/uiSlice";
import { ModalTypes } from "models/GeneralTypes/generalTypes";

// COMPONENTS

const DiscountCard = (props: IProps) => {
  // PROPS
  const {
    discountDetails = {
      discountText: "",
      amount: "",
      type: "",
      id: 0,
    },
    background = "",
    opacity = "",
  } = props;

  // CONSTANTS USING LIBRARIES
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  // CONSTANTS USING HOOKS

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleNavigate = () => {
    if (discountDetails.id) {
      navigate(`/discount/${discountDetails.id}`);
    }
  };

  const handleDeleteDiscount = (event) => {
    event.stopPropagation();
    dispatch(
      toggleModalState({
        isVisible: true,
        type: ModalTypes.DISCOUNT_DELETE_CONFIRMATION,
        discount: discountDetails.id,
      })
    );
  };

  return (
    <Style.DiscountCardContainer
      onClick={handleNavigate}
      background={background && background}
      discountDetails={discountDetails}
    >
      <Style.DiscountDetails opacity={opacity && opacity}>
        <Style.Title>DISCOUNT</Style.Title>
        <Style.Amount>{discountDetails?.amount || ""}</Style.Amount>
        <Style.Type>{discountDetails?.type || ""}</Style.Type>
        <Style.DiscountContainer>
          {discountDetails?.discountText || ""}
        </Style.DiscountContainer>
      </Style.DiscountDetails>
      <Style.LogoIcon opacity={opacity && opacity} src={LogoIcon} alt="" />
      {discountDetails?.isAvailable && (
        <Style.DeleteButton
          src={DeleteButton}
          onClick={(e) => handleDeleteDiscount(e)}
        />
      )}
    </Style.DiscountCardContainer>
  );
};

export default DiscountCard;
